import { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { AddAssemblyRealestateButton } from "./AddAssemblyRealestateButton";
import { AddAssemblyRealestateModal } from "./add-realestate-modal/AddAssemblyRealestateModal";
import { RootStoreContext } from "src/stores/RootStore";

const AddAssemblyRealestateButtonAndModalBase = () => {
    const { assemblyStore } = useContext(RootStoreContext);

    const onClickAddRealestateButton = useCallback(() => {
        assemblyStore.setIsAddAssemblyRealestateModalDisplayed(true);
    }, [assemblyStore]);

    return (
        <>
            <AddAssemblyRealestateModal />
            <AddAssemblyRealestateButton onClick={onClickAddRealestateButton} />
        </>
    );
};

export const AddAssemblyRealestateButtonAndModal = Sentry.withProfiler(
    observer(AddAssemblyRealestateButtonAndModalBase)
);
